import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';

export const env = (requiredVariables: string[]) => {
  for (const v of requiredVariables) {
    if (!process.env[v]) {
      console.error(`Environment variable '${v}' is required but not set.`);
      process.exit(1);
    }
  }
};

env(['REACT_APP_API']);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
